import { SegmentSchema } from '@sondermind/segment';

import { RequestSessionExitClickTarget } from '../enums/request-session-exits.enum';
import { PaymentTypes } from '../quick-checkout-form.model';

export enum PublicRequestSessionSegmentEvents {
  PSL_DIRECTORY_LINK_CLICKED = 'Provider directory link on PSL clicked',
  PSL_QUICK_CHECKOUT_EXITED = 'Quick checkout form exited',
  PSL_QUICK_CHECKOUT_COMPLETED = 'Quick checkout form submitted',
  PSL_QUICK_CHECKOUT_FORM_LOCATION_CHANGED = 'PSL quick checkout form - LOCATION changed',
  PSL_QUICK_CHECKOUT_FORM_PAYMENT_METHOD_CHANGED = 'PSL quick checkout form - PAYMENT METHOD changed',
  PSL_QUICK_CHECKOUT_FORM_PAYMENT_PLAN_CHANGED = 'PSL quick checkout form - PAYMENT PLAN changed',
  PSL_QUICK_CHECKOUT_FORM_PERSONAL_INFO_CHANGED = 'PSL quick checkout form - PERSONAL INFO changed',
  PSL_QUICK_CHECKOUT_FORM_ALL_FIELDS_COMPLETED = 'PSL quick checkout form - ALL FIELDS completed',
  PSL_QUICK_CHECKOUT_REDIRECTED_TO_AUTH0 = 'PSL quick checkout redirected to Auth0',
  PUBLIC_REQUEST_SESSION_CLICKED = 'Request a Session clicked',
  PSL_EMAIL_RESEND_REQUESTED = '"Resend email" clicked on PSL quick checkout',
  PSL_SUPPORT_LINK_CLICKED = 'Support link clicked on PSL quick checkout: sondermind.com/contact-us',
}

interface IPublicRequestSessionDirectoryLinkClickData {
  buttonClicked: string;
  currentProviderId: number;
  queryParams: {
    state?: string;
    insurance?: string;
    genders?: string[];
    specialties?: string[];
    modalities?: string[];
  };
}

interface IPublicSessionRequestTimeSlotDetails {
  startTime: string;
  endTime: string;
  hoursFromRequestSubmission: number;
  sessionType: string;
}

interface IPublicRequestSessionSubmittedData {
  personaProviderId: number;
  sessionRequested: boolean;
  sessionRequestDetails: IPublicSessionRequestTimeSlotDetails | null;
}

interface IPublicRequestSessionResendEmailClickData {
  personaProviderId: number;
}

interface IPublicRequestSessionSupportLinkClickData {
  personaProviderId: number;
}

interface IPublicRequestSessionExitedData {
  exitedBy: RequestSessionExitClickTarget;
}

interface IPublicRequestSessionLocationChangeData {
  selectedState: string;
  isProviderCredentialedInState: boolean;
}

interface IPublicRequestSessionPaymentMethodChangeData {
  selectedPaymentMethod: PaymentTypes;
}

interface IPublicRequestSessionPaymentPlanChangeData {
  selectedPaymentPlan: string;
}

interface IPublicRequestSessionPersonalInfoChangeData {
  description: string;
}

export interface IPublicRequestSessionClickData {
  accepting: boolean;
  personaProviderId: number;
  sessionRequestDetails: IPublicSessionRequestTimeSlotDetails | null;
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface IPublicRequestSessionAllFieldsCompletedData {}

/* eslint-disable max-len */
export interface IPublicRequestSessionSegmentSchema extends SegmentSchema {
  [PublicRequestSessionSegmentEvents.PSL_DIRECTORY_LINK_CLICKED]: IPublicRequestSessionDirectoryLinkClickData;
  [PublicRequestSessionSegmentEvents.PSL_QUICK_CHECKOUT_COMPLETED]: IPublicRequestSessionSubmittedData;
  [PublicRequestSessionSegmentEvents.PSL_QUICK_CHECKOUT_EXITED]: IPublicRequestSessionExitedData;
  [PublicRequestSessionSegmentEvents.PUBLIC_REQUEST_SESSION_CLICKED]: IPublicRequestSessionClickData;
  [PublicRequestSessionSegmentEvents.PSL_EMAIL_RESEND_REQUESTED]: IPublicRequestSessionResendEmailClickData;
  [PublicRequestSessionSegmentEvents.PSL_SUPPORT_LINK_CLICKED]: IPublicRequestSessionSupportLinkClickData;
  [PublicRequestSessionSegmentEvents.PSL_QUICK_CHECKOUT_FORM_LOCATION_CHANGED]: IPublicRequestSessionLocationChangeData;
  [PublicRequestSessionSegmentEvents.PSL_QUICK_CHECKOUT_FORM_PAYMENT_METHOD_CHANGED]: IPublicRequestSessionPaymentMethodChangeData;
  [PublicRequestSessionSegmentEvents.PSL_QUICK_CHECKOUT_FORM_PAYMENT_PLAN_CHANGED]: IPublicRequestSessionPaymentPlanChangeData;
  [PublicRequestSessionSegmentEvents.PSL_QUICK_CHECKOUT_FORM_PERSONAL_INFO_CHANGED]: IPublicRequestSessionPersonalInfoChangeData;
  [PublicRequestSessionSegmentEvents.PSL_QUICK_CHECKOUT_FORM_ALL_FIELDS_COMPLETED]: IPublicRequestSessionAllFieldsCompletedData;
}
/* eslint-enable max-len */
